import { string, object } from 'yup'
import translateIntlMsgString from '../../../../../../utils/translateIntlMsgString'

const catalogueProductBaseSideNavModalValidationSchema = object().shape({
	name: string().required(translateIntlMsgString('validationSchema.require')),
})

export default catalogueProductBaseSideNavModalValidationSchema
